import { useAtom } from "jotai";
import { useCallback } from "react";
import {
  taskNameAtom,
  effortAtom,
  impactAtom,
  dueDateAtom,
  descriptionAtom,
  categoryAtom,
} from "../../store/atoms/taskAtoms.js";

// Task Form State Hook
export const useTaskForm = () => {
  const [taskName, setTaskName] = useAtom(taskNameAtom);
  const [effort, setEffort] = useAtom(effortAtom);
  const [impact, setImpact] = useAtom(impactAtom);
  const [dueDate, setDueDate] = useAtom(dueDateAtom);
  const [description, setDescription] = useAtom(descriptionAtom);
  const [category, setCategory] = useAtom(categoryAtom);

  const clearForm = useCallback(() => {
    setTaskName("");
    setEffort(null);
    setImpact(null);
    setDueDate(null);
    setDescription("");
    setCategory("");
  }, [
    setTaskName,
    setEffort,
    setImpact,
    setDueDate,
    setDescription,
    setCategory,
  ]);

  return {
    taskName,
    setTaskName,
    effort,
    setEffort,
    impact,
    setImpact,
    dueDate,
    setDueDate,
    description,
    setDescription,
    category,
    setCategory,
    clearForm,
  };
};
